<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <IndexHeader></IndexHeader>

                <div class="widget-heading">
                    <div class="row">
                        <div class="text-start">
                            <template v-if="loadingRate">
                                <span>Pobieram kurs €...</span>
                            </template>
                            <template v-else>
                                <span v-if="exchangeRates.rates">
                                    EUR:
                                    <b>{{ exchangeRates.rates.eur }}</b>

                                    USD:
                                    <b>{{ exchangeRates.rates.usd }}</b>

                                    ({{ exchangeRates.date }})
                                </span>
                                <span v-else class="text-danger">Nie udało się pobrać kursu €. Odśwież stronę lub
                                    spróbuj ponownie później.</span>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="widget-content">
                    <div>
                        <ejs-grid ref="articlesGrid" id="articlesGrid" height="54vh" :dataSource="dataManager"
                            :allowTextWrap='false' :allowExcelExport='true' :allowPaging="true" :allowSorting='true'
                            :allowFiltering='true' :allowReordering='true' :allowResizing='true'
                            :showColumnChooser='true' :allowSelection='true' :enablePersistence='true'
                            :actionBegin="actionBegin" :actionComplete="actionComplete" :pageSettings="pageSettings"
                            :editSettings="editSettings" :filterSettings="filterOptions" :toolbar="toolbar"
                            :contextMenuItems="contextMenuItems" :contextMenuClick="clickContextMenuHandler"
                            :rowDataBound="onRowDataBound" :rowSelected="rowSelected" :keyPressed="onKeyDown"
                            :beforeBatchAdd="beforeBatchAdd" :cellEdit="onCellEdit" :beforeBatchSave="beforeBatchSave"
                            :toolbarClick="toolbarClick" :cellSave="cellSave">
                            <e-columns>
                                <e-column field="id" headerText="ID" width="92" :isPrimaryKey="true"
                                    :allowEditing="false"></e-column>
                                <e-column field="catalog_number" headerText="Nr katalogowy" width="150"
                                    :edit="catalogEditor" :filter="filterDefault"></e-column>
                                <e-column field="model" headerText="Model" width="150"
                                    :filter="filterDefault"></e-column>
                                <e-column field="article_unit.id" headerText="J.m." width="150" editType="dropdownedit"
                                    :dataSource="units" foreignKeyValue='name' foreignKeyField='id'
                                    :filter='filterUnits'></e-column>
                                <e-column field="description" headerText="Nazwa/Opis" :defaultValue="null" width="200"
                                    :filter="filterDefault"></e-column>
                                <e-column field="details" headerText="Szczegóły" type="string" :defaultValue="null"
                                    width="200" :filter="filterDefault"></e-column>
                                <e-column field="link" headerText="Link" :defaultValue="null" :filter="filterDefault"
                                    type="string" :template="'linkTemplate'"></e-column>
                                <e-column field="created_at" headerText="Utworzono" width="150" type="date"
                                    format="dd.MM.yyyy HH:mm:ss" :allowEditing="false"></e-column>
                                <e-column field="created_by.id" headerText="Utworzył" width="150" :allowEditing="false"
                                    :dataSource="users" foreignKeyValue='name' foreignKeyField='id'
                                    :defaultValue="$page.props.user.id" :filter="filterCreatedBy"></e-column>
                                <e-column field="producer_id" headerText="Producent" width="150" editType="dropdownedit"
                                    :dataSource="copyproducers" foreignKeyValue="name" foreignKeyField="id"
                                    :filter="filterProducers">
                                </e-column>
                                <e-column field="customer_category.id" headerText="Kategoria" width="250"
                                    editType="dropdownedit" :dataSource="categories" foreignKeyValue='name'
                                    foreignKeyField='id' :filter='filterCategories'></e-column>

                                <template v-if="hasPermission('canViewArticlesPricesAndHistory')">
                                    <e-column field="vat" headerText="vat" editType="numericedit"
                                        :filter="filterDefault" textAlign="Right"></e-column>
                                    <e-column field="price_netto" headerText="Cena Netto" width="150" format="N2"
                                        type="number" editType="numericedit" textAlign="Right"></e-column>
                                    <e-column field="price_brutto" headerText="Cena Brutto" width="150" format="N2"
                                        type="number" editType="numericedit" textAlign="Right"></e-column>
                                    <e-column field="currency" headerText="Waluta" width="150" editType="dropdownedit"
                                        :dataSource="copycurrencys" foreignKeyValue="name" foreignKeyField="id"
                                        :filter="filterCurrencys">
                                    </e-column>
                                    <e-column field="price_netto_zl" headerText="Cena Netto PLN" width="150" format="N2"
                                        type="number" editType="numericedit" textAlign="Right"></e-column>
                                    <e-column field="price_brutto_zl" headerText="Cena brutto PLN" width="150"
                                        format="N2" type="number" editType="numericedit" textAlign="Right"></e-column>

                                </template>

                                <e-column field="photos" headerText="Zdjęcia" width="200" :template="'imageTemplate'"
                                    :allowEditing="false" :allowFiltering="false"></e-column>
                                <e-column field="location" headerText="Lokalizacja" :defaultValue="null" width="200"
                                    :filter="filterDefault"></e-column>
                                <e-column field="available_items.quantity" headerText="Ilość/Stany magazynowe"
                                    width="150" type="number" format="N2" :allowEditing="false"
                                    textAlign="Right"></e-column>

                                <template v-if="hasPermission('canViewArticlesPricesAndHistory')">
                                    <e-column field="value_net" headerText="Wartość (netto)" width="150" format="N"
                                        type="number" editType="numericedit" :allowEditing="false"
                                        textAlign="Right"></e-column>
                                    <e-column field="value_gross" headerText="Wartość (brutto)" width="150" format="N"
                                        type="number" editType="numericedit" :allowEditing="false"
                                        textAlign="Right"></e-column>
                                </template>

                                <e-column field="suppliers_short_names" headerText="Dostawca" width="150"
                                    editType="string" :filter='filterSuppliers' :edit="suppliersParams"></e-column>
                                <e-column field="is_usluga" headerText="Usługa" width="120" editType="dropdownedit"
                                    :dataSource="isUslugaOptions" foreignKeyField="id" foreignKeyValue="name"
                                    :filter="filterDefault">
                                </e-column>

                                <e-column field="files" headerText="Załączniki" width="200"
                                    :template="'attachmentsTemplate'" :allowEditing="false" :allowFiltering="false" />
                            </e-columns>

                            <template v-slot:linkTemplate="{ data }">
                                <a class="link link-primary" target="_blank" rel="noopener noreferrer"
                                    :href=data.link>{{
                                        data.link
                                    }}</a>
                            </template>

                            <template v-slot:imageTemplate="{ data }">
                                <div v-if="data.photos && data.photos.length > 0">
                                    <button type="button" class="btn-invisible" data-bs-toggle="modal"
                                        data-bs-target="#gallery" @click="setGalleryToModal(data)">
                                        <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie" width="150" />
                                        <span v-if="data.photos.length > 1" class="d-block mt-1 bold">
                                            +{{ data.photos.length - 1 }} więcej
                                        </span>
                                    </button>
                                </div>
                                <div v-else class="text-center">
                                    <button v-if="hasPermission('canEditArticles')" type="button"
                                        class="btn btn-xs btn-outline-default" data-bs-toggle="modal"
                                        data-bs-target="#gallery" @click="setGalleryToModal(data)">
                                        Dodaj zdjęcie
                                    </button>
                                </div>
                            </template>

                            <template v-slot:attachmentsTemplate="{ data }">
                                <div>
                                    <a v-if="data.files && data.files.length" class="text-primary"
                                        :href="route('articles.files.show', { file: data.files[0].id })"
                                        target="_blank">
                                        {{ data.files[0].original_name }}
                                    </a>

                                    <div class="text-muted mt-1">
                                        <button class="btn btn-xs btn-outline-default"
                                            @click="showAttachmentsModal(data)">Pokaż wszystkie {{
                                                Object.keys(data.files).length || ''
                                            }}
                                        </button>
                                    </div>
                                </div>
                            </template>

                        </ejs-grid>
                    </div>

                    <ViewArticleDetails :selectedArticle="selectedArticle"></ViewArticleDetails>
                    <hr>
                    <ArticleReplacements :selectedArticle="selectedArticle"></ArticleReplacements>

                </div>
            </div>
        </div>


        <!-- Modal z dodawaniem artykułu do magazynu -->
        <AddArticleToWarehouseModal ref="addArticleToWarehouseRef" :selectedArticle="selectedArticle"
            @added-success="successMsg" @added-error="errorMsg" />
        <AddArticleModal ref="addArticleModalRef" @save-article="createArticleFromModal" @added-success="successMsg"
            @added-error="errorMsg" :units="units" :categories="categories" :producers="copyproducers"
            :currencys="copycurrencys" :suppliers="suppliers" :exchangeRates="exchangeRates" />
        <!-- Modal z dodawaniem załączników -->
        <ArticleFilesModal v-if="showFilesModal" :article="selectedArticle" @close="showFilesModal = false"
            @refresh="this.$refs.articlesGrid.refresh()" @added-success="successMsg" @added-error="errorMsg" />


        <!-- Modal z galerią zdjęć -->
        <div class="modal fade" id="gallery" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog modal-xxl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Galeria zdjęć</h5>
                        <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Zamknij">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="selectedArticle">
                        <div v-if="selectedArticle.photos && selectedArticle.photos.length > 0">
                            <div class="row">
                                <!-- Wyświetlanie zdjęć -->
                                <div v-for="(photo, index) in selectedArticle.photos" :key="index"
                                    class="col image-column text-center">
                                    <a :href="`/${photo.photo_path}`" target="_blank">
                                        <img class="img-fluid" :src="`/${photo.photo_path}`"
                                            :alt="`Zdjęcie ${index + 1}`" style="max-width: 45vw; max-height: 85vh;" />
                                    </a>

                                    <!-- Ustawienie zdjęcia jako głównego -->
                                    <div v-if="hasPermission('canEditArticles')">
                                        <div v-if="selectedArticle.photos.length > 1 && index > 0"
                                            class="square-radio text-color radio-primary custom-control custom-radio mt-4 text-center">
                                            <input type="radio" class="custom-control-input" :id="`photo_${index}`"
                                                name="default" :value="photo.id" v-model="photo.default"
                                                @click="confirmSetDefault(photo.id)" />
                                            <label class="custom-control-label" :for="`photo_${index}`"> Ustaw jako
                                                zdjęcie
                                                główne </label>
                                        </div>

                                        <!-- Usuwanie zdjęcia -->
                                        <div v-if="photo.id">
                                            <button class="btn btn-danger mt-2"
                                                @click="confirmDeletePhoto(photo.id)">Usuń
                                                zdjęcie</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Formularz dodawania zdjęcia -->
                        <div class="mt-4" v-if="hasPermission('canEditArticles')">
                            <hr>
                            <form @submit.prevent="uploadPhoto(selectedArticle.id)">
                                <div class="form-group">
                                    <label for="photoUpload">Dodaj nowe zdjęcie</label>
                                    <input type="file" class="form-control" id="photoUpload" @change="handleFileUpload">
                                </div>
                                <button type="submit" class="btn btn-primary mt-2">Zapisz zdjęcie</button>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal z historią artykułu -->
        <ArticleHistoryGrid v-if="showHistoryModal" @close="showHistoryModal = false" :selectedArticle="selectedArticle"
            :currencys="copycurrencys" />

    </AppLayout>
</template>

<script>
import AppLayout from "../../../Layouts/App.vue";
import { useForm, usePage } from "@inertiajs/vue3";
import { AutoComplete, MultiSelect } from '@syncfusion/ej2-vue-dropdowns';
import { TextBox } from '@syncfusion/ej2-inputs';
import {
    ColumnChooser,
    ColumnDirective,
    ColumnsDirective,
    ContextMenu,
    Edit,
    ExcelExport,
    Filter,
    ForeignKey,
    GridComponent,
    Page,
    Reorder,
    Resize,
    Sort,
    Toolbar,
    VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import { createElement } from "@syncfusion/ej2-base";
import { DataManager, WebMethodAdaptor, Predicate, Query } from '@syncfusion/ej2-data';
import { DropDownList } from "@syncfusion/ej2-dropdowns";
import moment from "moment";
import ArticleHistoryGrid from '@/Pages/Warehouses/Articles/ArticleHistoryGrid.vue';
import AddArticleToWarehouseModal from '@/Pages/Warehouses/Articles/AddArticleToWarehouseModal.vue';
import AddArticleModal from '@/Pages/Warehouses/Articles/AddArticleModal.vue';
import ViewArticleDetails from "./ViewArticlePriceHistoryDetails.vue";
import ArticleReplacements from "./ArticleReplacements.vue";
import ArticleFilesModal from "./ArticleFilesModal.vue";
import IndexHeader from "@/Pages/Warehouses/Articles/IndexHeader.vue";

const { hasRole, hasPermission } = usePermission();

let dropInstanceFilterUnits;
export default {
    computed: {
        id() {
            return id
        },

        catalogNumbers() {
            return this.articles.map(article => article.catalog_number).filter((value, index, self) => self.indexOf(value) === index);
        },
    },

    components: {
        ArticleFilesModal,
        IndexHeader,
        ViewArticleDetails,
        ArticleReplacements,
        AppLayout,
        hasRole,
        hasPermission,
        MultiSelect,
        ArticleHistoryGrid,
        AddArticleToWarehouseModal,
        AddArticleModal,
        'ejs-grid': GridComponent,
        'e-columns': ColumnsDirective,
        'e-column': ColumnDirective
    },

    provide: {
        grid: [Page, ContextMenu, Edit, Toolbar, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, VirtualScroll]
    },

    props: {
        units: Object,
        categories: Object,
        warehouses: Object,
        producers: Object,
        currencys: Object,
        suppliers: Object,
        users: Object,
        exchangeRate: Object,
        table_settings: {
            type: Object,
            default: null
        },
		now_restore_table: {
				type: Number,
				default: 1
		}
    },

    mounted() {
		this.restoreTableIfNeeded();
        this.getNBPExchangeRate();
    },

    data() {
        let ddElem;
        let multiSelectObj;

        const createSuppliersFn = () => {
            ddElem = document.createElement('input');
            return ddElem;
        };

        const readSuppliersFn = () => {
            return multiSelectObj.value.join(",");
        };

        const destroySuppliersFn = () => {
            multiSelectObj.destroy();
        };

        const writeSuppliersFn = (args) => {
            const selectedValues = args.rowData.suppliers_short_names ? args.rowData.suppliers_short_names.split(",") : [];
            multiSelectObj = new MultiSelect({
                value: selectedValues,
                dataSource: this.suppliers,
                fields: { text: "short_name", value: "short_name" },
                placeholder: 'Wybierz dostawców',
                mode: 'Box',
                allowFiltering: true,
                popupHeight: '200px',
                closePopupOnSelect: false,
            });

            multiSelectObj.appendTo(ddElem);
        };

        return {
            tableSettingsApplied: false,
            hasTableSettings: false,
            hasPermission,
            currentUserId: this.$page.props.user.id,
            photoForm: useForm({
                article_id: null,
                default: null,
                photo_path: null,
            }),
            articles: [],
            copyproducers: [
				{
					id: 0,
					name: ''
				},
				...(this.producers || [])
			],
            copycurrencys: this.currencys,
            loadingRate: false,
            exchangeRates: {
                date: null,
                rates: {
                    pln: 1,
                    eur: 0,
                    usd: 0
                }
            },
            currentEditingRowData: {},
            showDeleted: false,
            dataManager: new DataManager({
                url: route('articles.get'),
                adaptor: new WebMethodAdaptor(),
                crossDomain: true,
                headers: [
                    { 'X-CSRF-TOKEN': usePage().props.csrf_token }
                ]
            }),
            pageSettings: { pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100] },
            showHistoryModal: false,
            showFilesModal: false,
            selectedFile: null,
            isAddingNew: false,
            selectedArticle: null,
            taskGridKey: 0,
            contextMenuItems: this.getContextMenu(),
            filterOptions: { type: "Menu" },
            toolbar: this.getToolbar(),
            editSettings: this.getEditSettings(),
            selectionOptions: { type: 'Multiple', cellSelectionMode: 'Box', mode: 'Cell' },
            suppliersParams: {
                create: createSuppliersFn,
                destroy: destroySuppliersFn,
                read: readSuppliersFn,
                write: writeSuppliersFn
            },
            filterDefault: { operator: 'contains', params: { minLength: 2 } },
            isUslugaOptions: [
                { id: 1, name: 'Tak' },
                { id: 0, name: 'Nie' }
            ],

            filterUnits: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.units,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj jednostki',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            filterCreatedBy: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.users,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj kto stworzył',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },

            filterCategories: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.categories,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj kategorii',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            filterProducers: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.copyproducers,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj Producenta',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            filterCurrencys: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.copycurrencys,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj walutę',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
            filterSuppliers: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.suppliers,
                            fields: { text: 'short_name', value: 'short_name' },
                            placeholder: 'Szukaj dostawców',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },
        }
    },
    watch: {
        table_settings: {
            immediate: true,
            deep: true,
            handler(value) {
                this.hasTableSettings = !!(value?.settings);

                this.$nextTick(() => {
                    const grid = this.$refs.articlesGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                });
            }
        }
    },
    methods: {
		  restoreTableIfNeeded() {
			if (this.now_restore_table !== 0) {
			  return;
			}

			let grid = this.$refs.articlesGrid;

			if (!grid || !grid.$el || !grid.ej2Instances) {
			  return;
			}
			let gridName = 'grid' + grid.$el.id;
			grid.ej2Instances.enablePersistence = false;
			window.localStorage.setItem(gridName, "");
			grid.ej2Instances.destroy();
			(function stripIdsFromUrl() {
			  try {
				const url = new URL(window.location.href);
				url.searchParams.delete('ids');
				url.searchParams.delete('ids[]');
				history.replaceState(
				  history.state,
				  '',
				  url.toString()
				);
			  } catch (e) {
				const href = window.location.href;
				const cleaned = href
				  .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
				  .replace(/[?&]$/, '');
				history.replaceState(
				  history.state,
				  '',
				  cleaned
				);
			  }
			})();
			this.applyTableSettings();
			location.reload();
		  },
        applyTableSettings() {
            const grid = this.$refs.articlesGrid?.ej2Instances;

            if (!grid || !this.table_settings?.settings) {
                return;
            }

            let settings;

            try {
                settings = JSON.parse(this.table_settings.settings);
            } catch (error) {
                console.error('Błąd odczytu ustawień tabeli:', error);
                return;
            }

            if (!Array.isArray(settings)) {
                return;
            }

            settings.forEach(setting => {
                if (!setting.field) {
                    return;
                }

                const column = grid.columns.find(
                    col => col.field === setting.field
                );

                if (!column) {
                    return;
                }

                if (setting.width !== undefined) {
                    column.width = setting.width;
                }

                column.visible = setting.visible !== false;
            });

            grid.refreshColumns();

            const savedFields = settings
                .filter(setting => setting.field)
                .sort((a, b) => a.index - b.index)
                .map(setting => setting.field);
            const currentFields = grid.columns
                .filter(column => column.field)
                .map(column => column.field);

            savedFields.forEach((field, targetIndex) => {
                const currentIndex = currentFields.indexOf(field);

                if (currentIndex === -1 || currentIndex === targetIndex) {
                    return;
                }

                const targetField = currentFields[targetIndex];

                if (!targetField) {
                    return;
                }

                grid.reorderColumns(
                    field,
                    targetField
                );

                currentFields.splice(currentIndex, 1);
                currentFields.splice(targetIndex, 0, field);
            });

            grid.refreshColumns();
        },

        getRate(currencyId) {

            const currency = this.copycurrencys.find(c => c.id == currencyId);

            if (!currency) {
                return 1;
            }

            return parseFloat(
                this.exchangeRates?.rates?.[currency.name.toLowerCase()] ?? 1
            );
        },

        queryCellInfo(args) {
            const row = args.data;
            const isAdmin = this.isAdmin();
            const isOwner = row.created_by?.id === this.currentUserId;
            /*
            if (!isOwner) {
              args.cell.classList.add('not-editable');
            }*/
        },

        cloneToModal(sourceRow) {
            const clone = JSON.parse(JSON.stringify(sourceRow));
            clone.id = null;
            this.$nextTick(() => {
                const modal = this.$refs.addArticleModalRef;
                modal.resetForm();
                modal.setDataFromClone(clone);
                modal.show();
            });
        },

        onArticleAdded(newArticle) {
            const grid = this.$refs.articlesGrid.ej2Instances;
            grid.addRecord(newArticle, 0);
            grid.refresh();
            this.successMsg('Dodano nowy artykuł');
        },
        async createArticleFromModal(payload) {

            const result = await this.checkCatalogNumber(
                payload.catalog_number,
                payload.model,
                payload.producer_id,
                payload.producer_name
            );

            if (result.articles?.length > 0) {

                const blocked = await this.articleAlreadyExist(result);

                if (blocked) {
                    this.isAddingNew = false;
                    return;
                }
            }

            this.$inertia.post(route('articles.saveChanges'), {
                added: [payload],
            }, {
                only: [
                    'errors',
                    'flash',
                    'newRecords',
                    'articles',
                    'producers'
                ],
                preserveState: true,

                onSuccess: (page) => {

                    const flashError = page.props.flash?.error;

                    if (flashError) {
                        Toast.fire({
                            position: 'top-end',
                            toast: false,
                            icon: 'warning',
                            title: 'Błąd zapisu',
                            html: flashError,
                            showConfirmButton: true
                        });

                        const grid = this.$refs.articlesGrid?.ej2Instances;

                        if (grid) {
                            grid.refresh();
                        }

                        this.isAddingNew = false;
                        return;
                    }

                    this.copyproducers = page.props.producers;
                    this.copycurrencys = page.props.currencys;

                    this.$refs.articlesGrid.ej2Instances.refresh();

                    this.successMsg('Dane zostały zapisane!');
                    this.$makeClean();

                    this.$refs.addArticleModalRef.hide();
                    this.$refs.addArticleModalRef.resetForm();
                },

                onError: (errors) => {
                    console.error(
                        'Błąd podczas zapisywania danych:',
                        errors
                    );

                    this.errorMsg('Błąd podczas zapisywania danych.');
                    this.isAddingNew = false;
                }
            });
        },
        async getNBPExchangeRate() {

            this.loadingRate = true;
            try {
                const response = await axios.get(route('api.exchange-rates'));
                this.exchangeRates = response.data;
            } catch (e) {
                this.exchangeRates = {
                    date: null,
                    rates: {
                        pln: 1,
                        eur: 0,
                        usd: 0
                    }
                };
            }
            this.loadingRate = false;
        },

        getEditSettings() {
            return {
                allowEditing: hasPermission('canEditArticles'),
                allowAdding: hasPermission('canEditArticles'),
                allowDeleting: hasPermission('canEditArticles'),
                showConfirmDialog: false,
                showDeleteConfirmDialog: false,
                mode: 'Batch',
                newRowPosition: 'Top',
            };
        },

        getToolbar() {
            const tools = [];

            if (hasPermission('canEditArticles')) {
                tools.push("Add");
            }

            if (hasPermission('canDelArticles')) {
                tools.push({ text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn' });
            }
            if (hasPermission('canEditArticles')) {
                tools.push("Update");
                tools.push("Cancel");
            }

            tools.push(
                { text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters' },
                { text: 'Historia wpisu', prefixIcon: 'e-clock', id: 'show_history_btn', disabled: false },
                { text: "Search", prefixIcon: 'e-search', id: "search", align: 'center' },
                { text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
            if (this.hasTableSettings) {
                tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
            }
            tools.push({ text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
                { text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right' },
                "ColumnChooser"
            );

            return tools;
        },

        userCanModify() {
            let rights = 0;
            if (this.usersCanChange) {
                rights = this.usersCanChange.find(email => email === this.$page.props.user.email);
            }

            return !(rights === undefined || rights <= 0);
        },

        beforeBatchAdd(args) {
            if (this.isAddingNew) {
                args.cancel = true;
            } else {
                this.isAddingNew = true;
            }
        },

        onCellEdit(args) {
            if (args.rowData.deleted_at) {
                args.cancel = true;
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon: 'warning',
                    title: 'Edycja',
                    html: 'Nie można edytować usuniętych rekordów.',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                    timer: 2500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true
                });

                return;
            }
            const isAdmin = this.isAdmin();
            const isOwner = args.rowData.created_by?.id === this.$page.props.user.id;
        },

        cloneRowAndStartEdit(sourceRow) {
            const grid = this.$refs.articlesGrid.ej2Instances;
            const clone = JSON.parse(JSON.stringify(sourceRow));
            clone.id = `tmp_${Date.now()}`;
            delete clone.created_at;
            delete clone.updated_at;
            clone.catalog_number = '';
            clone.deleted_at = null;
            clone.files = [];
            clone.photos = [];
            clone.available_items = { quantity: 0 };
            const srcIndex = grid.getRowIndexByPrimaryKey(sourceRow.id);
            grid.addRecord(clone, srcIndex + 1);
            this.$nextTick(() => {
                try {
                    const newIndex = grid.getRowIndexByPrimaryKey(sourceRow.id);
                    grid.editModule.editCell(newIndex, 'id');
                    this.isAddingNew = true;
                } catch (e) {
                    console.warn('Nie udało się wejść w edycję nowego wiersza:', e);
                }
            });
        },

        async toolbarClick(args) {
            if (args.item.id === 'articlesGrid_update' || args.item.id === 'articlesGrid_cancel') {
                this.isAddingNew = false;
            }
            if (args.item.id === 'articlesGrid_add' || args.item.text === 'Add') {
                args.cancel = true;

                this.$refs.addArticleModalRef.show();
                return;
            }
            if (args.item.id === 'delete_btn') {
                const selectedRecords = this.$refs.articlesGrid.ej2Instances.getSelectedRecords();

                if (selectedRecords.length > 0) {
                    this.$refs.articlesGrid.ej2Instances.deleteRecord('id', selectedRecords[0]);
                }
            }
            if (args.item.id === 'show_history_btn') {
                if (this.selectedArticle) {
                    this.showHistoryModal = true;
                }
            }
            if (args.item.id === 'reset_filters') {
                this.$refs.articlesGrid.clearFiltering();
            }
            if (args.item.id === 'save') {
                const grid = this.$refs.articlesGrid?.ej2Instances;

                if (!grid) {
                    console.warn('Grid nie został znaleziony');
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                    return;
                }
                const tableId = 'articlesGrid';
                const settings = grid.columns.map((column, index) => ({
                    field: column.field || null,
                    index: index,
                    width: column.width,
                    visible: column.visible !== false
                }));
                try {
                    const response = await axios.post('/table-settings', {
                        tableId: tableId,
                        columns: JSON.stringify(settings)
                    });
                    this.hasTableSettings = true;
                    grid.toolbar = this.getToolbar();
                    this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
                } catch (error) {
                    this.errorMsg("Konfiguracja tabeli nie została zapisana!");
                }
            }
            if (args.item.id === 'delete-set') {
                const tableId = 'articlesGrid';
                try {
                    const response = await axios.delete('/table-settings-delete', {
                        data: {
                            tableId: tableId
                        }
                    }
                    );
                    this.hasTableSettings = false;
                    const grid = this.$refs.articlesGrid?.ej2Instances;

                    if (grid) {
                        grid.toolbar = this.getToolbar();
                    }
                    this.successMsg(
                        "Konfiguracja tabeli została pomyślnie usunięta!"
                    );
                } catch (error) {
                    this.errorMsg(
                        "Konfiguracja tabeli nie została usunięta!"
                    );
                }
            }

            if (args?.item.id === 'restore') {
                let grid = this.$refs.articlesGrid;
                let gridName = 'grid' + grid.$el.id;
                grid.ej2Instances.enablePersistence = false;
                window.localStorage.setItem(gridName, "");
                grid.ej2Instances.destroy();
                (function stripIdsFromUrl() {
                    try {
                        const url = new URL(window.location.href);
                        url.searchParams.delete('ids');
                        url.searchParams.delete('ids[]');
                        history.replaceState(history.state, '', url.toString());
                    } catch (e) {
                        const href = window.location.href;
                        const cleaned = href
                            .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
                            .replace(/[?&]$/, '');
                        history.replaceState(history.state, '', cleaned);
                    }
                })();
                this.applyTableSettings();
                location.reload();
            }

            if (args.item.id === 'excelexport') {
                this.$refs.articlesGrid.excelExport({
                    fileName: `Lista artykułów.xlsx`
                });
            }
        },

        async beforeBatchSave(args) {
            const requiredErrors = [];
            const isAdmin = this.isAdmin();
            for (const record of args.batchChanges.addedRecords || []) {
                const producerName =
                    record.producer?.name ||
                    record.producer_name ||
                    record.producerSearch ||
                    '';

                const result = await this.checkCatalogNumber(
                    record.catalog_number,
                    record.model,
                    record.producer_id || null,
                    producerName.trim()
                );

                if (result.articles?.length > 0) {
                    const blocked = await this.articleAlreadyExist(result);

                    if (blocked) {
                        args.cancel = true;
                        return;
                    }
                }
            }

            if (!isAdmin) {
                const validateRow = (row, type = 'changed') => {
                    const missing = [];

                    if (!row.catalog_number || row.catalog_number.trim() === '') {
                        missing.push('Numer katalogowy');
                    }

                    if (!row.model || row.model.trim() === '') {
                        missing.push('Model');
                    }

                    if (!row.description || row.description.trim() === '') {
                        missing.push('Nazwa / Opis');
                    }

                    const unitId = row.article_unit?.id || row.unit_id || null;

                    if (!unitId) {
                        missing.push('Jednostka miary');
                    }

                    if (missing.length) {
                        requiredErrors.push({
                            id: row.id,
                            type,
                            fields: missing
                        });
                    }
                };

                args.batchChanges.addedRecords?.forEach(
                    r => validateRow(r, 'nowy')
                );

                args.batchChanges.changedRecords?.forEach(
                    r => validateRow(r, 'zmieniony')
                );

                if (requiredErrors.length) {
                    args.cancel = true;

                    let html = '<div style="text-align:left">';

                    requiredErrors.forEach(err => {
                        html += `<b>Wiersz ID:</b> ${err.id} (${err.type})<br>`;
                        html += `
                    <span style="color:grey">
                        Brakuje: ${err.fields.join(', ')}
                    </span>
                    <br><br>
                `;
                    });

                    html += '</div>';

                    Toast.fire({
                        position: 'top-end',
                        toast: true,
                        icon: 'warning',
                        title: 'Nie można zapisać — brakuje wymaganych pól',
                        html,
                        timer: 3000,
                        showConfirmButton: false,
                    });

                    return;
                }
            }

            this.$makeClean();

            try {
                const mapFields = (record) => ({
                    id: record.id,
                    catalog_number: record.catalog_number,
                    model: record.model,
                    unit_id: record.article_unit?.id,
                    description: record.description,
                    details: record.details,
                    link: record.link,
                    created_by: record.created_by?.id,
                    category_id: record.customer_category?.id,
                    vat: record.vat,
                    price_netto_zl: record.price_netto_zl,
                    price_brutto_zl: record.price_brutto_zl,
                    price_netto: record.price_netto,
                    price_brutto: record.price_brutto,
                    photos: record.photos,
                    location: record.location,
                    is_usluga: record.is_usluga,
                    warehouse_id: record.warehouse?.id,

                    producer_id: record.producer_id || null,

                    producer_name:
                        record.producer?.name ||
                        record.producer_name ||
                        record.producerSearch ||
                        '',

                    currency: record.currency,
                    stock_quantity: record.stock_quantity,
                    income: record.income,
                    outflow: record.outflow,
                    value_net: record.value_net,
                    value_gross: record.value_gross,
                    suppliers: record.suppliers_short_names,
                });

                const updatedRecords = args.batchChanges.changedRecords.map(mapFields);
                const addedRecords = args.batchChanges.addedRecords.map(mapFields);
                const deletedRecords = args.batchChanges.deletedRecords.map(record => ({ id: record.id }));

                this.$inertia.post(route('articles.saveChanges'), {
                    updated: updatedRecords,
                    added: addedRecords,
                    deleted: deletedRecords,
                }, {
                    only: ['errors', 'flash', 'newRecords', 'updatedRecords', 'deletedRecords', 'articles'],
                    preserveState: true,

                    onSuccess: (page) => {
                        const flashError = page.props.flash?.error;

                        if (flashError) {
                            Toast.fire({
                                position: 'top-end',
                                toast: false,
                                icon: 'warning',
                                title: 'Błąd zapisu',
                                html: flashError,
                                showConfirmButton: true
                            });

                            const grid = this.$refs.articlesGrid?.ej2Instances;
                            if (grid) {
                                if (grid.editModule && grid.editModule.formObj) {
                                    grid.editModule.formObj.resetForm();
                                }
                                grid.closeEdit();
                                grid.showSpinner = false;
                                grid.refresh();
                            }

                            this.isAddingNew = false;
                            args.cancel = true;
                            return;
                        }

                        const newRecords = page.props.newRecords || [];
                        const updatedRecordsFromServer = page.props.updatedRecords || [];

                        newRecords.forEach((newRecord) => {
                            const index = this.$refs.articlesGrid.ej2Instances.getIndexByRowData({ id: newRecord.temp_id });
                            if (index !== -1) {
                                this.$refs.articlesGrid.ej2Instances.updateRow(index, newRecord);
                            } else {
                                this.$refs.articlesGrid.ej2Instances.addRecord(newRecord);
                            }
                        });

                        updatedRecordsFromServer.forEach((updatedRecord) => {
                            const index = this.$refs.articlesGrid.ej2Instances.getIndexByRowData({ id: updatedRecord.id });
                            if (index !== -1) {
                                this.$refs.articlesGrid.ej2Instances.updateRow(index, updatedRecord);
                            }
                        });

                        this.successMsg('Dane zostały zapisane!');
                        this.$makeClean();
                        this.$refs.articlesGrid.ej2Instances.refresh();
                    },

                    onError: (errors) => {
                        console.error('Błąd podczas zapisywania danych:', errors);
                        this.errorMsg('Błąd podczas zapisywania danych.');

                        this.isAddingNew = false;
                        if (this.$refs.articlesGrid?.ej2Instances) {
                            this.$refs.articlesGrid.ej2Instances.closeEdit();
                            this.$refs.articlesGrid.ej2Instances.showSpinner = false;
                        }
                    },
                });
            } catch (error) {
                console.error('Błąd try/catch podczas beforeBatchSave:', error);
                this.$makeDirty();
                this.isAddingNew = false;
                if (this.$refs.articlesGrid?.ej2Instances) {
                    this.$refs.articlesGrid.ej2Instances.closeEdit();
                    this.$refs.articlesGrid.ej2Instances.showSpinner = false;
                }
                this.errorMsg('Błąd podczas zapisywania danych.');
            }
        },



        cellSave(args) {

            if (args.previousValue === args.value) return;

            const grid = this.$refs.articlesGrid.ej2Instances;
            const row = args.rowData;
            const column = args.columnName;
            const value = parseFloat(args.value) || 0;
            const vat = parseFloat(row.vat || 0);
            const updatedRow = { ...row };
            const rate = this.getRate(
                column === 'currency' ? args.value : row.currency
            );

            if (column === 'vat') {

                updatedRow.price_brutto_zl = (
                    parseFloat(updatedRow.price_netto_zl || 0) *
                    (1 + value / 100)
                ).toFixed(2);

                updatedRow.price_brutto = (
                    parseFloat(updatedRow.price_netto || 0) *
                    (1 + value / 100)
                ).toFixed(2);
            }

            if (column === 'price_netto_zl') {

                updatedRow.price_brutto_zl = (
                    value * (1 + vat / 100)
                ).toFixed(2);

                updatedRow.price_netto = (
                    value / rate
                ).toFixed(2);

                updatedRow.price_brutto = (
                    updatedRow.price_netto * (1 + vat / 100)
                ).toFixed(2);
            }

            if (column === 'price_netto') {

                updatedRow.price_netto_zl = (
                    value * rate
                ).toFixed(2);

                updatedRow.price_brutto_zl = (
                    updatedRow.price_netto_zl * (1 + vat / 100)
                ).toFixed(2);

                updatedRow.price_brutto = (
                    value * (1 + vat / 100)
                ).toFixed(2);
            }

            if (column === 'price_brutto_zl') {

                updatedRow.price_netto_zl = (
                    value / (1 + vat / 100)
                ).toFixed(2);

                updatedRow.price_netto = (
                    updatedRow.price_netto_zl / rate
                ).toFixed(2);

                updatedRow.price_brutto = (
                    value / rate
                ).toFixed(2);
            }

            if (column === 'price_brutto') {

                updatedRow.price_netto = (
                    value / (1 + vat / 100)
                ).toFixed(2);

                updatedRow.price_brutto_zl = (
                    value * rate
                ).toFixed(2);

                updatedRow.price_netto_zl = (
                    updatedRow.price_brutto_zl / (1 + vat / 100)
                ).toFixed(2);
            }

            if (column === 'currency') {
                updatedRow.price_netto = row.price_netto;
                updatedRow.price_netto_zl = (
                    parseFloat(row.price_netto) * rate
                ).toFixed(2);
                updatedRow.price_brutto = (
                    parseFloat(row.price_netto) *
                    (1 + vat / 100)
                ).toFixed(2);
                updatedRow.price_brutto_zl = (
                    parseFloat(updatedRow.price_brutto) * rate
                ).toFixed(2);
            }
            const quantity = parseFloat(updatedRow.stock_quantity || 0);
            updatedRow.value_net = (
                parseFloat(updatedRow.price_netto_zl || 0) * quantity
            ).toFixed(2);
            updatedRow.value_gross = (
                updatedRow.value_net * (1 + vat / 100)
            ).toFixed(2);

            const rowIndex = grid.getRowIndexByPrimaryKey(row.id);

            if (rowIndex !== -1) {
                grid.updateRow(rowIndex, updatedRow);
            }
        },

        updateCurrencyFromZl(priceNettoZl) {

            const rate = this.getRate(this.currentEditingRowData.currency);

            const priceNetto = (
                priceNettoZl / rate
            ).toFixed(2);

            this.currentEditingRowData.price_netto = priceNetto;

            this.updateCell('price_netto', priceNetto);

            this.updateBrutto(priceNettoZl, this.currentEditingRowData.vat);
        },
        updateZlFromCurrency(priceNetto) {

            const rate = this.getRate(this.currentEditingRowData.currency);

            const priceNettoZl = (
                priceNetto * rate
            ).toFixed(2);

            this.currentEditingRowData.price_netto_zl = priceNettoZl;

            this.updateCell('price_netto_zl', priceNettoZl);

            this.updateBrutto(priceNettoZl, this.currentEditingRowData.vat);
        },
        updateBrutto(priceNettoZl, vat) {

            if (isNaN(vat)) return;

            const priceBruttoZl = (
                priceNettoZl * (1 + vat / 100)
            ).toFixed(2);

            this.currentEditingRowData.price_brutto_zl = priceBruttoZl;

            this.updateCell('price_brutto_zl', priceBruttoZl);

            const rate = this.getRate(this.currentEditingRowData.currency);

            const priceNetto = (
                priceNettoZl / rate
            );

            const priceBrutto = (
                priceNetto * (1 + vat / 100)
            ).toFixed(2);

            this.currentEditingRowData.price_brutto = priceBrutto;

            this.updateCell('price_brutto', priceBrutto);
        },
        updateNettoFromBrutto(priceBruttoZl, vat) {

            if (vat <= 0) return;

            const priceNettoZl = (
                priceBruttoZl / (1 + vat / 100)
            ).toFixed(2);

            this.currentEditingRowData.price_netto_zl = priceNettoZl;

            this.updateCell('price_netto_zl', priceNettoZl);

            this.updateCurrencyFromZl(priceNettoZl);
        },

        calculateTotal(priceNettoZl, priceNettoEur, vat, quantity) {
            const valueNet = (priceNettoZl * quantity).toFixed(2);
            const valueGross = (priceNettoZl * quantity * (1 + vat / 100)).toFixed(2);
            this.currentEditingRowData.value_net = valueNet;
            this.currentEditingRowData.value_gross = valueGross;
            this.$refs.articlesGrid.ej2Instances.getColumnByField('value_net').allowEditing = true;
            this.$refs.articlesGrid.ej2Instances.getColumnByField('value_gross').allowEditing = true;
            this.updateCell('value_net', valueNet);
            this.updateCell('value_gross', valueGross);
        },

        updateCell(columnName, value) {
            const currentRecords = this.$refs.articlesGrid.ej2Instances.getCurrentViewRecords();
            const rowIndex = currentRecords.findIndex(record => record.id === this.currentEditingRowData.id);
            this.$refs.articlesGrid.ej2Instances.updateCell(rowIndex, columnName, value);
            if (columnName === 'value_net' || columnName === 'value_gross') {
                this.$refs.articlesGrid.ej2Instances.getColumnByField(columnName).allowEditing = false;
            }
        },


        async checkCatalogNumber(catalogNumber, model, producerId, producerName) {
            try {
                const response = await axios.post(
                    route('article.check-catalog-number-if-exists'),
                    {
                        catalog_number: catalogNumber,
                        model: model,
                        producer_id: producerId || null,
                        producer_name: producerName || '',
                    }
                );

                return response.data;

            } catch (error) {
                console.error(
                    'Błąd podczas sprawdzania numeru katalogowego:',
                    error
                );

                return {
                    same_producer_exists: false,
                    articles: []
                };
            }
        },

        async articleAlreadyExist(result) {

            const articles = result.articles || [];

            if (!articles.length) {
                return false;
            }

            let html = `
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Nr Kat.</th>
          <th>Model</th>
          <th>Opis</th>
          <th>Producent</th>
        </tr>
      </thead>
      <tbody>
  `;

            articles.forEach(article => {
                html += `
      <tr>
        <td>${article.catalog_number || ''}</td>
        <td>${article.model || ''}</td>
        <td>${article.description || ''}</td>
        <td>${article.producer?.name || 'Brak producenta'}</td>
      </tr>
    `;
            });

            html += `
      </tbody>
    </table>
  `;

            const sameProducer = result.same_producer_exists;

            await Toast.fire({
                position: 'center',
                toast: false,
                icon: sameProducer ? 'error' : 'warning',

                title: sameProducer
                    ? 'Taki artykuł już istnieje'
                    : 'Istnieją artykuły z tym numerem i modelem',

                html: sameProducer
                    ? `
          ${html}

          <div style="
            margin-top:10px;
            color:red;
            font-weight:bold;
          ">
            Artykuł z tym numerem katalogowym,
            modelem i producentem już istnieje.
            Dodanie zostało zablokowane.
          </div>
        `
                    : html,

                timer: false,
                showCancelButton: false,
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Ok',
            });

            return sameProducer;
        },

        onRowDataBound(args) {
            if (!this.tableSettingsApplied) {
                this.tableSettingsApplied = true;
                this.applyTableSettings();
            }

            if (args.data.deleted_at) { 
                args.row.classList.add('deleted-row');
            }
        },

        rowSelected(args) {
            this.selectedArticle = args.data;

            if (this.selectedArticle)
                this.$refs.articlesGrid.ej2Instances.toolbarModule.enableItems(document.querySelector('#show_history_btn'), true);
        },

        dateFormatter(field, data) {
            const date = data.created_at ? data.created_at : null;
            if (date) {
                try {
                    return moment(date).format('DD.MM.YYYY HH:mm:ss');
                } catch (error) {
                    return data
                }
            }

            return '';
        },

        onKeyDown: function (args) {
            let keyCode = args.which || args.keyCode;
            let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

            if (isCtrlKey && keyCode === 83) {
                args.preventDefault();
                if (this.userCanModify) {
                    let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
                    let buttons = toolbar.querySelectorAll('.e-toolbar-item');
                    let updateButton = buttons[2].querySelector('button');
                    if (updateButton) {
                        updateButton.click();
                    }
                }
            }
        },

        actionBegin(args) {
            if (args.requestType === 'searching') {
                const keys = args.searchString.split(';');
                let predicate;

                if (this.$refs.articlesGrid.ej2Instances.searchSettings.key !== '') {
                    this.values = args.searchString;

                    keys.forEach((key) => {
                        const lowerKey = key.toLowerCase();

                        this.$refs.articlesGrid.ej2Instances.getColumns().forEach((col) => {
                            let field = col.field;
                            let value = key;

                            if (field === 'producer_id') {
                                const match = this.copyproducers.find(p =>
                                    p.name.toLowerCase().includes(lowerKey)
                                );

                                if (match) {
                                    value = match.id;
                                } else {
                                    return;
                                }
                            }
                            if (field === 'currency') {
                                const match = this.copycurrencys.find(p =>
                                    p.name.toLowerCase().includes(lowerKey)
                                );

                                if (match) {
                                    value = match.id;
                                } else {
                                    return;
                                }
                            }
                            const predic = new Predicate(field, 'contains', value, true);

                            if (!predicate) {
                                predicate = predic;
                            } else {
                                predicate = predicate.or(predic);
                            }
                        });
                    });

                    this.$refs.articlesGrid.ej2Instances.query = new Query().where(predicate);
                    this.$refs.articlesGrid.ej2Instances.searchSettings.key = '';
                }

                this.refresh = true;
                this.valueAssign = true;
                this.removeQuery = true;

                return;
            }

            if (args.requestType === 'beginEdit') {
                const row = args.rowData;

                const isAdmin = this.isAdmin();
                const isOwner = row.created_by?.id === this.$page.props.user.id;
                const isDeleted = !!row.deleted_at;

                /*   if (!isOwner || isDeleted) {
                     args.cancel = true;
                     return;
                   }*/
            }
        },
        actionComplete(args) {
            if (args.requestType === "refresh" && this.valueAssign) {
                document.getElementById(
                    this.$refs.articlesGrid.ej2Instances.element.id + "_searchbar"
                ).value = this.values;
                this.valueAssign = false;
            } else if (
                document.getElementById(
                    this.$refs.articlesGrid.ej2Instances.element.id + "_searchbar"
                ).value === "" &&
                args.requestType === "refresh" &&
                this.removeQuery
            ) {
                this.$refs.articlesGrid.ej2Instances.query = new Query();
                this.removeQuery = false;
                this.$refs.articlesGrid.ej2Instances.refresh();
            }
        },


        successMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'success',
                title: 'Sukces!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        errorMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'warning',
                title: 'Błąd!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        setGalleryToModal(data) {
            this.photoForm.article_id = data.id;
        },

        uploadPhoto(articleId) {
            if (this.selectedFile) {
                this.photoForm.article_id = articleId;
                this.photoForm.photo_path = this.selectedFile;
                this.photoForm.post(route('article.photos.store', { article: articleId }), {
                    only: ['flash'],
                    onSuccess: (response) => {
                        const photos = response.props.flash.data?.photos;
                        if (photos)
                            this.selectedArticle.photos = photos;
                    }
                });
            }
        },

        handleFileUpload(event) {
            this.selectedFile = event.target.files[0];
        },

        setDefaultPhoto(photoId) {
            this.photoForm.post(route('article.photos.setDefault', {
                only: ['articles', 'flash'],
                article: this.photoForm.article_id,
                photo: photoId
            }), {
                onSuccess: (resp) => {
                    const updatedArt = this.articles.find(article => article.id === this.photoForm.article_id);
                    this.selectedArticle = updatedArt;
                    this.photoForm.default = true;
                    this.successMsg(resp.props.flash.success);
                },
                onError: (error) => {
                    console.error('Błąd podczas ustawiania zdjęcia głównego:', error);
                    this.errorMsg(resp.props.flash.error)
                }
            });
        },

        async confirmSetDefault(photoId) {
            await Toast.fire({
                title: 'Czy na pewno chcesz ustawić to zdjęcie jako główne?',
                icon: 'question',
                position: 'center',
                toast: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Tak, ustaw jako główne!',
                cancelButtonText: 'Anuluj',
                timer: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setDefaultPhoto(photoId);
                } else {
                    this.photoForm.default = null;
                }
            });
        },

        async confirmDeletePhoto(photoId) {
            await Toast.fire({
                title: 'Czy na pewno chcesz usunąć to zdjęcie?',
                icon: 'warning',
                html: 'Ta akcja jest nie odwracalna!',
                position: 'center',
                toast: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Tak, usuń całkowicie!',
                cancelButtonText: 'Anuluj',
                timer: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deletePhoto(photoId);
                }
            });
        },

        deletePhoto(photoId) {
            this.photoForm.delete(route('article.photos.destroy', { photo: photoId }), {
                only: ['articles', 'flash'],
                onSuccess: () => {
                    const photoIndex = this.selectedArticle.photos.findIndex(photo => photo.id === photoId);
                    if (photoIndex !== -1) {
                        this.selectedArticle.photos.splice(photoIndex, 1);
                    }
                }
            });
        },

        isAdmin() {
            return hasRole('ADMIN');
        },

        showAttachmentsModal(article) {
            this.selectedArticle = article;
            this.showFilesModal = true;
        },

        catalogEditor() {
            return {
                create: () => {
                    const elem = document.createElement('input');
                    return elem;
                },
                read: () => {
                    return this.autoCompleteObj.value;
                },
                destroy: () => {
                    if (this.autoCompleteObj) {
                        this.autoCompleteObj.destroy();
                    }
                },
                write: (args) => {
                    this.autoCompleteObj = new AutoComplete({
                        dataSource: this.catalogNumbers,
                        placeholder: 'Wpisz lub wybierz istniejący numer katalogowy',
                        allowCustom: true,
                        value: args.rowData ? args.rowData.catalog_number : ''
                    });
                    this.autoCompleteObj.appendTo(args.element);
                }
            };
        },

        getContextMenu() {

            const contextMenu = [];
            contextMenu.push(
                { text: 'Klonuj', target: '.e-content', id: 'clone_btn' }
            );
            /*
          if (hasPermission('canWarehouseDispositions')) {
            contextMenu.push(
               {separator: true},
            {text: 'Wprowadź artykuł do magazynu', target: '.e-content', id: 'add_article_to_warehouse'}
            );
          }
    */
            return contextMenu;
        },

        clickContextMenuHandler(args) {
            if (args.item.id === 'clone_btn') {
                const row = args.rowInfo?.rowData;
                if (row) this.cloneToModal(row);
                return;
            }

            if (args.item.id === 'add_article_to_warehouse') {
                this.selectedArticle = args.rowInfo.rowData;
                this.$nextTick(() => {
                    this.$refs.addArticleToWarehouseRef.show();
                });
            }
        }
    }
}
</script>

<style scoped>
.image-column {
    padding: 15px;
    border: 1px solid #ddd;
    align-items: center;
}

.btn-invisible {
    background-color: transparent;
    padding: 5px;
}
</style>